module.exports = __webpack_public_path__ + "static/media/hello.1af7add3.png";